import Config from '@/config';
import {
  PasswordRecoveryConfirmParams,
  PasswordRecoveryParams,
  PasswordRecoveryResponse,
} from '@/types/api/user';
import http, { HttpPromise } from './http';

export interface DocumentsParams {
  page?: number
  pageSize?: number
  documentDateStart?: string
  documentDateEnd?: string
  objectName?: string
  documentType?: 'contract' | 'upd' | 'protocol' | 'agentReport' | 'additionalAgreement' | 'reconciliationAct' | 'other'
}

export default {
  info: async (): Promise<HttpPromise> => http.get(`${Config.apiHost}/user/info/`),
  update: async (params): Promise<HttpPromise> => http.post(`${Config.apiHost}/user/info/update/`, params),
  changeEmail: async (params): Promise<HttpPromise> => http.post(`${Config.apiHost}/user/changeEmail/`, params),
  restorePassword: async (params: PasswordRecoveryParams): Promise<PasswordRecoveryResponse> => http.post(`${Config.apiHost}/pub/password-recovery/`, params),
  restorePasswordConfirm: async (params: PasswordRecoveryConfirmParams): Promise<PasswordRecoveryResponse> => http.post(`${Config.apiHost}/pub/password-recovery/confirm/`, params),
  getDocuments: async (params: DocumentsParams): Promise<HttpPromise> => http.get(`${Config.apiHost}/user/documents/`, { params }),
};
